
import React from 'react';
import { Button } from "@/components/ui/button";
import { ArrowLeft } from "lucide-react";

interface DealersCityHeaderProps {
  formattedCity: string;
  dealersCount: number;
  onGoBack: () => void;
}

export function DealersCityHeader({ 
  formattedCity, 
  dealersCount, 
  onGoBack 
}: DealersCityHeaderProps) {
  return (
    <div className="mb-6">
      <Button 
        variant="ghost" 
        size="sm" 
        className="mb-2"
        onClick={onGoBack}
      >
        <ArrowLeft className="mr-2 h-4 w-4" />
        Torna a tutti i compro oro
      </Button>
      
      <h1 className="text-2xl md:text-3xl font-bold">Compro Oro a {formattedCity}</h1>
      <p className="text-muted-foreground">
        {dealersCount > 0 
          ? `Trova il miglior compro oro a ${formattedCity}`
          : `Non sono stati trovati compro oro a ${formattedCity}`
        }
      </p>
    </div>
  );
}
